package com.sddamico.swigmore.ds.feedback

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.SwEffects
import com.sddamico.swigmore.ds.core.Card
import com.sddamico.swigmore.ds.core.CardVariant
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.typeCaps
import com.sddamico.swigmore.ds.typeDisplay
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

/** Big-number tile from the commissioner's desk ("26/30 · BALLOTS IN"). */
@Composable
fun StatTile(value: String, label: String, modifier: Modifier = Modifier) {
  Card(modifier, variant = CardVariant.Plain, padding = "14px 16px", radius = SwEffects.radiusCard) {
    Div(attrs = Modifier.typeDisplay("34px").toAttrs()) { Text(value) }
    Div(attrs = Modifier.typeCaps("9px", ".18em").css("margin-top" to "6px").toAttrs()) { Text(label) }
  }
}
